export const appStatic = {"directory":"static"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"DYB 셔틀버스 APP"},{"name":"author","content":"Edubrain"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"},{"name":"theme-color","content":"#FFFFFF"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"DYBBUS"},{"hid":"og:url","property":"og:url","content":"https://devbus.dybedu.com"},{"hid":"og:image","property":"og:image","content":"https://devbus.dybedu.com/og_DYBBUS.png"},{"hid":"og:description","property":"og:description","content":"DYB 셔틀버스 APP"},{"hid":"og:image:width","property":"og:image:width","content":"512"},{"hid":"og:image:height","property":"og:image:height","content":"512"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon_dev.svg"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","title":"DYBBUS","htmlAttrs":{"lang":"ko-KR"}}

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true